(function () {
  function init() {
    document.querySelectorAll(".cushion-step-section").forEach((section) => {
      const scene   = section.querySelector(".scene");
      const dot     = section.querySelector(".blur-dot");
      const shoe    = section.querySelector(".center-wrap");
      const heading = section.querySelector(".headline");
      const magText = dot ? dot.querySelector(".mag-text") : null;

      if (!scene || !dot || !shoe) return;

      function clamp(v, min, max) {
        return Math.max(min, Math.min(max, v));
      }

      function update() {
        const rect  = scene.getBoundingClientRect();
        const total = scene.offsetHeight - window.innerHeight;

        let progress = -rect.top / total;
        progress = clamp(progress, 0, 1);

        /* DOT MOVE — unchanged from original */
        const travel = heading
          ? heading.offsetWidth * 0.6
          : window.innerWidth * 0.37;

        const moveX = progress * travel;
        const moveY = Math.sin(progress * Math.PI) * -12;

        dot.style.transform = `translate3d(${moveX}px, ${moveY}px, 0)`;

        /* SHOE STEP — unchanged from original */
        const step = Math.sin(progress * Math.PI * 6) * 14;
        shoe.style.transform = `translateX(-50%) translateY(${step}px)`;

        /* MAGNIFIER
           mag-text lives inside blur-dot which already has
           overflow:hidden + border-radius:50%, so no clip-path needed.

           Math:
           - offsetX/Y = where heading's top-left is, in dot-local space
           - We position mag-text there so it aligns with the heading below
           - transform-origin is set to the dot center in mag-text's own space
           - scale(1.6) from that origin = letter under dot appears 1.6x bigger
        */
        if (magText && heading) {
          const lensRadius  = dot.offsetWidth / 2;
          const dotRect     = dot.getBoundingClientRect();
          const headingRect = heading.getBoundingClientRect();

          /* heading position relative to dot top-left, in screen px */
          const offsetX = headingRect.left - dotRect.left;
          const offsetY = headingRect.top  - dotRect.top;

          magText.style.width  = headingRect.width + "px";
          magText.style.left   = offsetX + "px";
          magText.style.top    = offsetY + "px";

          /*
            Dot center in mag-text coordinate space:
            dot center is at (lensRadius, lensRadius) inside dot.
            mag-text's own (0,0) is at (dotRect.left + offsetX, dotRect.top + offsetY)
            = (headingRect.left, headingRect.top) on screen.
            So dot center in mag-text space:
              x = (dotRect.left + lensRadius) - headingRect.left = lensRadius - offsetX
              y = (dotRect.top  + lensRadius) - headingRect.top  = lensRadius - offsetY
            Scaling from this point keeps the letter under the dot fixed
            at the dot center but 1.6x bigger — exactly a magnifier.
          */
          const originX = lensRadius - offsetX;
          const originY = lensRadius - offsetY;

          magText.style.transformOrigin = `${originX}px ${originY}px`;
          magText.style.transform       = "scale(1.4)";
        }
      }

      update();
      window.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
    });
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
